// extracted by mini-css-extract-plugin
module.exports = {"searchbarstyle":"SearchBar_searchbarstyle__6WLx_"};